import React, { useState, useEffect } from "react";
import { industriesData } from "./industriesData";
import { FaChevronRight, FaChevronDown } from "react-icons/fa";
import styles from "./BusinessesforSale.module.css";
import { filterlocations } from "../../../Services/APIrequests";
import { businessForSalefilterapi } from "../../../Services/APIrequests";
import { FaFilter } from "react-icons/fa6";
import { RotatingLines } from "react-loader-spinner";
import {
  getDistinctCity,
  getDistinctState,
} from "../../../Services/APIrequests";

const Filters = React.memo(({ onFilterChange }) => {
  const [openState, setOpenState] = useState({
    categories: {},
    subcategories: {},
  });
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [selectedListedBy, setSelectedListedBy] = useState([]);
  const [selectedLegalEntities, setSelectedLegalEntities] = useState([]);
  const [locations, setLocations] = useState([]);
  const [cities, setCities] = useState([]); // Define cities state
  const [states, setStates] = useState([]);

  const [yearRange, setYearRange] = useState({ min: 0, max: 0 });
  const [filteredLocations, setFilteredLocations] = useState([]);
  const [initial, setIsInitial] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [localInvestorFilters, setLocalInvestorFilters] = useState({
    operationType: "all",
    withWebsite: "all",
    city: "all",
    state: "all",
  });
  const [filterRange, setFilterRange] = useState({
    Authorisedcapital: "",
    paidUpCapital: "",
    investmentRange: "",
    turnover: "",
    pat: "",
  });

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        setIsLoading(true);
        const response = await filterlocations();
        if (Array.isArray(response.data.data)) {
          setLocations(response.data.data);
        } else {
          console.error(
            "Expected an array of locations, but got:",
            response.data
          );
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      } finally {
        setIsLoading(false);
      }
    };

    const fetchCitiesAndStates = async () => {
      try {
        const cityResponse = await getDistinctCity();
        const stateResponse = await getDistinctState();

        if (Array.isArray(cityResponse.data.data)) {
          setCities(cityResponse.data.data); // Set cities correctly
        }

        if (Array.isArray(stateResponse.data.data)) {
          setStates(stateResponse.data.data); // Set states correctly
        }
      } catch (error) {
        console.error("Error fetching cities or states:", error);
      }
    };

    fetchLocations();
    fetchCitiesAndStates();
  }, []);

  const handleCityChange = (e) => {
    const value = e.target.value;
    setLocalInvestorFilters({
      ...localInvestorFilters,
      // city: e.target.value,
      city: value === "all" ? "" : value,
    });
  };

  const handleStateChange = (e) => {
    const value = e.target.value;
    setLocalInvestorFilters({
      ...localInvestorFilters,
      // state: e.target.value,
      state: value === "all" ? "" : value,
    });
  };

  const handleYearRangeChange = (e) => {
    const [min, max] = e.target.value.split("-").map(Number);
    setYearRange({ min, max });
  };

  const applyFilters = async () => {
    // Filter out industries that are not selected (like "manufacturing" or "withwebsite")
    const industriesFilter = selectedIndustries.filter(
      (item) => item !== "manufacturing" && item !== "withwebsite"
    );

    const { operationType, withWebsite, city, state } = localInvestorFilters;

    // Initialize variables for min/max values (defaults to null)
    let patMin = null,
      patMax = null;
    if (filterRange.pat !== "all") {
      const [min, max] = filterRange.pat.split("-").map(Number);
      patMin = min;
      patMax = max;
    }

    let authorisedCapitalMin = null,
      authorisedCapitalMax = null;
    if (filterRange.Authorisedcapital !== "all") {
      const [min, max] = filterRange.Authorisedcapital.split("-").map(Number);
      authorisedCapitalMin = min;
      authorisedCapitalMax = max;
    }

    let paidUpCapitalMin = null,
      paidUpCapitalMax = null;
    if (filterRange.paidUpCapital !== "all") {
      const [min, max] = filterRange.paidUpCapital.split("-").map(Number);
      paidUpCapitalMin = min;
      paidUpCapitalMax = max;
    }

    let investmentRangeMin = null,
      investmentRangeMax = null;
    if (filterRange.investmentRange !== "all") {
      const [min, max] = filterRange.investmentRange.split("-").map(Number);
      investmentRangeMin = min;
      investmentRangeMax = max;
    }

    let turnoverMin = null,
      turnoverMax = null;
    if (filterRange.turnover !== "all") {
      const [min, max] = filterRange.turnover.split("-").map(Number);
      turnoverMin = min;
      turnoverMax = max;
    }

    const requestBody = {};

    if (operationType !== "all") requestBody.operation_type = operationType;

    if (withWebsite !== "all") requestBody.with_website = withWebsite;

    if (industriesFilter.length) requestBody.industries = industriesFilter;

    if (selectedLegalEntities.length)
      requestBody.legal_entities = selectedLegalEntities;

    // if (location && location !== "all") requestBody.locations = [location];

    if (city && city !== "all") requestBody.city = [city];
    if (state && state !== "all") requestBody.state = [state];

    if (yearRange.min !== 0 || yearRange.max !== 0)
      requestBody.years = yearRange;

    if (patMin || patMax) requestBody.pat = { min: patMin, max: patMax };

    if (authorisedCapitalMin || authorisedCapitalMax)
      requestBody.authorised_capital = {
        min: authorisedCapitalMin,
        max: authorisedCapitalMax,
      };

    if (paidUpCapitalMin || paidUpCapitalMax)
      requestBody.paid_up_capital = {
        min: paidUpCapitalMin,
        max: paidUpCapitalMax,
      };

    if (investmentRangeMin || investmentRangeMax)
      requestBody.investment = {
        min: investmentRangeMin,
        max: investmentRangeMax,
      };

    if (turnoverMin || turnoverMax)
      requestBody.turnover = { min: turnoverMin, max: turnoverMax };

    if (Object.keys(requestBody).length === 0) {
      console.warn("No filters selected, skipping API request.");
      return;
    }

    try {
      const response = await businessForSalefilterapi(requestBody);
      if (response.status === 200) {
        onFilterChange(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching filtered businesses:", error);
    }
  };

  useEffect(() => {
    if (!initial) {
      applyFilters();
    } else {
      setIsInitial(false);
    }
  }, [
    selectedIndustries,
    selectedLegalEntities,
    filteredLocations,
    yearRange,
    localInvestorFilters.operationType,
    localInvestorFilters.withWebsite,
    localInvestorFilters.location,
    filterRange,
    localInvestorFilters.city,
    localInvestorFilters.state,
  ]);

  const handleFilterRangeChange = (type, value) => {
    setFilterRange((prevState) => ({
      ...prevState,
      [type]: value,
    }));
  };

  const toggleCategory = (category) => {
    setOpenState((prevState) => ({
      ...prevState,
      categories: {
        ...prevState.categories,
        [category]: !prevState.categories[category],
      },
    }));
  };

  const toggleSubcategory = (category, subcategory) => {
    setOpenState((prevState) => ({
      ...prevState,
      subcategories: {
        ...prevState.subcategories,
        [`${category}-${subcategory}`]:
          !prevState.subcategories[`${category}-${subcategory}`],
      },
    }));
  };

  const handleFilterChange = (value) => {
    setSelectedIndustries((prevSelected) => {
      if (prevSelected.includes(value)) {
        return prevSelected.filter((industry) => industry !== value);
      } else {
        return [...prevSelected, value];
      }
    });
  };

  const handleCategorySelect = (category) => {
    const allItems = industriesData
      .find((industryCategory) => industryCategory.category === category)
      ?.subcategories.flatMap((subcategory) => subcategory.items);

    setSelectedIndustries((prevSelected) => {
      if (allItems.every((item) => prevSelected.includes(item))) {
        return prevSelected.filter((item) => !allItems.includes(item));
      } else {
        return [...new Set([...prevSelected, ...allItems])];
      }
    });
  };

  const handleSubcategorySelect = (category, subcategory) => {
    const allItems = industriesData
      .find((industryCategory) => industryCategory.category === category)
      ?.subcategories.find((sub) => sub.name === subcategory)?.items;

    setSelectedIndustries((prevSelected) => {
      if (allItems.every((item) => prevSelected.includes(item))) {
        return prevSelected.filter((item) => !allItems.includes(item));
      } else {
        return [...new Set([...prevSelected, ...allItems])];
      }
    });
  };

  const handleLegalEntityChange = (value) => {
    setSelectedLegalEntities((prevSelected) => {
      if (prevSelected.includes(value)) {
        return prevSelected.filter((item) => item !== value);
      } else {
        return [...prevSelected, value];
      }
    });
  };

  return (
    <div className={styles.filtersContainer}>
      {/* Operation Type Filter */}

      <div className={styles.filtersContainer_main}>
        <h4 className={styles.toggleButton}>Select Operation Type</h4>
        <div className={styles.filterSectionone}>
          <select
            id="operationfilter"
            name="operation"
            className={styles.filterselectinput}
            onChange={(e) =>
              setLocalInvestorFilters({
                ...localInvestorFilters,
                // operationType: e.target.value,
                operationType: e.target.value === "" ? null : e.target.value,
              })
            }
            value={localInvestorFilters.operationType}
          >
            <option value="">All</option>
            <option value="manufacturing">Manufacturing</option>
            <option value="services">Services</option>
            <option value="Trading">Trading</option>
          </select>
        </div>
      </div>

      {/* Website Filter */}
      <div className={styles.filtersContainer_main}>
        <h4 className={styles.toggleButton}>Select Website Option</h4>
        <div className={styles.filterSectionone}>
          <select
            id="websiteFilter"
            name="with_website"
            className={styles.filterselectinput}
            onChange={(e) =>
              setLocalInvestorFilters({
                ...localInvestorFilters,
                withWebsite: parseInt(e.target.value, 10),
              })
            }
            value={localInvestorFilters.withWebsite}
          >
            <option value="">All</option>
            <option value="1">With Website</option>
            <option value="0">Without Website</option>
          </select>
        </div>
      </div>

      {/* Location Filter */}

      {/* State Filter */}
      <div className={styles.filtersContainer_main}>
        <h4>Select State</h4>
        <div className={styles.filterSectionone}>
          <select
            id="stateFilter"
            name="state"
            className={styles.filterselectinput}
            onChange={handleStateChange}
            value={localInvestorFilters.state}
          >
            <option value="">All</option>
            {states.map((state, index) => (
              <option key={index} value={state}>
                {state}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* City Filter */}
      <div className={styles.filtersContainer_main}>
        <h4>Select City</h4>
        <div className={styles.filterSectionone}>
          <select
            id="cityFilter"
            name="city"
            className={styles.filterselectinput}
            onChange={handleCityChange}
            value={localInvestorFilters.city}
          >
            <div>
            <option value="">All</option>
            {cities.map((city, index) => (
              <option key={index} value={city}>
                {city}
              </option>
            ))}
            </div>
          </select>
        </div>
      </div>

      {/* Industries Filter */}
      <div className={styles.filtersContainer_main}>
        <h4 className={styles.toggleButton}>Industries</h4>
        <div className={styles.filterSectionone}>
          <div className={styles.subList}>
            {industriesData.map((industryCategory) => (
              <div key={industryCategory.category} className={styles.category}>
                <div
                  className={styles.categoryTitle}
                  onClick={() => toggleCategory(industryCategory.category)}
                >
                  <FaChevronRight
                    style={{
                      transform: openState.categories[industryCategory.category]
                        ? "rotate(90deg)"
                        : "rotate(0deg)",
                      marginRight: "8px",
                      transition: "transform 0.2s",
                    }}
                  />
                  <input
                    type="checkbox"
                    onChange={() =>
                      handleCategorySelect(industryCategory.category)
                    }
                    checked={industryCategory.subcategories.every(
                      (subcategory) =>
                        subcategory.items.every((item) =>
                          selectedIndustries.includes(item)
                        )
                    )}
                    style={{ marginLeft: "10px" }}
                  />
                  {industryCategory.category}
                </div>
                {openState.categories[industryCategory.category] && (
                  <div className={styles.subcategoryList}>
                    {industryCategory.subcategories.map((subcategory) => (
                      <div
                        key={subcategory.name}
                        className={styles.subcategory}
                      >
                        <div
                          className={styles.subcategoryTitle}
                          onClick={() =>
                            toggleSubcategory(
                              industryCategory.category,
                              subcategory.name
                            )
                          }
                        >
                          <FaChevronDown
                            style={{
                              transform: openState.subcategories[
                                `${industryCategory.category}-${subcategory.name}`
                              ]
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              marginRight: "8px",
                              transition: "transform 0.2s",
                            }}
                          />
                          <input
                            type="checkbox"
                            onChange={() =>
                              handleSubcategorySelect(
                                industryCategory.category,
                                subcategory.name
                              )
                            }
                            checked={subcategory.items.every((item) =>
                              selectedIndustries.includes(item)
                            )}
                            style={{ marginLeft: "10px" }}
                          />
                          {subcategory.name}
                        </div>
                        {openState.subcategories[
                          `${industryCategory.category}-${subcategory.name}`
                        ] && (
                          <div className={styles.checkboxList}>
                            {subcategory.items.map((item) => (
                              <label key={item}>
                                <input
                                  type="checkbox"
                                  value={item}
                                  onChange={() => handleFilterChange(item)}
                                  checked={selectedIndustries.includes(item)}
                                />
                                {item}
                              </label>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Vintage (Years) Filter */}
      <div className={styles.filtersContainer_main}>
        <h4>Vintage (Years)</h4>
        <div className={styles.filterSectionone}>
          <select
            onChange={handleYearRangeChange}
            value={`${yearRange.min}-${yearRange.max}`}
            className={styles.filterselectinput}
          >
            <option value="0-0">Select Year Range</option>
            <option value="0-5">0 to 5 Years</option>
            <option value="5-10">5 to 10 Years</option>
            <option value="10-20">10 to 20 Years</option>
            <option value="20-40">20 to 40 Years</option>
            <option value="40-50">40 to 50 Years</option>
            <option value="0-50">All</option>
          </select>
        </div>
      </div>

      {/* Legal Entity Filter */}
      <div className={styles.filtersContainer_main}>
        <h4>Legal Entity</h4>
        <div className={styles.filterSectionone}>
          {[
            "Sole Proprietorship",
            "Partnership",
            "Limited Liability Partnership",
            "Private Limited Company",
            "Public Limited Company",
            "Listed Company",
            "NBFC Companies",
          ].map((option) => (
            <label key={option}>
              <input
                type="checkbox"
                value={option}
                onChange={() => handleLegalEntityChange(option)}
                checked={selectedLegalEntities.includes(option)}
              />
              {option}
            </label>
          ))}
        </div>
      </div>

      {/* Authorised Capital Range */}
      <div className={styles.filtersContainer_main}>
        <h4>Authorised Capital</h4>
        <div className={styles.filterSectionone}>
          <select
            value={filterRange.Authorisedcapital}
            onChange={(e) =>
              handleFilterRangeChange("Authorisedcapital", e.target.value)
            }
            className={styles.filterselectinput}
          >
            <option value="">Select Authorised Capital</option>
            <option value="0-100000">0 to 1 Lakh</option>
            <option value="100000-500000">1 to 5 Lakh</option>
            <option value="500000-1000000">5 Lakh to 10 Lakh</option>
            <option value="1000000-50000000">10 Lakh to 50 Lakh</option>
            <option value="50000000- 100000000">50 Lakh to 1 Crore</option>
            <option value="100000000-Infinity">1 Crore and above</option>
          </select>
        </div>
      </div>

      {/* Paid Up Capital Range */}
      <div className={styles.filtersContainer_main}>
        <h4>Paid Up Capital</h4>
        <div className={styles.filterSectionone}>
          <select
            value={filterRange.paidUpCapital}
            onChange={(e) =>
              handleFilterRangeChange("paidUpCapital", e.target.value)
            }
            className={styles.filterselectinput}
          >
            <option value="">Select Paid Up Capital</option>
            <option value="0-100000">0 to 1 Lakh</option>
            <option value="100000-500000">1 to 5 Lakh</option>
            <option value="500000-1000000">5 Lakh to 10 Lakh</option>
            <option value="1000000-50000000">10 Lakh to 50 Lakh</option>
            <option value="50000000- 100000000">50 Lakh to 1 Crore</option>
            <option value="100000000-Infinity">1 Crore and above</option>
          </select>
        </div>
      </div>

      {/* Turn Over Range */}
      <div className={styles.filtersContainer_main}>
        <h4>Turn Over</h4>
        <div className={styles.filterSectionone}>
          <select
            value={filterRange.turnover}
            onChange={(e) =>
              handleFilterRangeChange("turnover", e.target.value)
            }
            className={styles.filterselectinput}
          >
            <option value="">Select Turn Over</option>
            <option value="0-100000">0 to 1 Lakh</option>
            <option value="100000-500000">1 to 5 Lakh</option>
            <option value="500000-1000000">5 Lakh to 10 Lakh</option>
            <option value="1000000-50000000">10 Lakh to 50 Lakh</option>
            <option value="50000000- 100000000">50 Lakh to 1 Crore</option>
            <option value="100000000-Infinity">1 Crore and above</option>
          </select>
        </div>
      </div>

      {/* PAT Range */}
      <div className={styles.filtersContainer_main}>
        <h4>PAT (Profit After Tax)</h4>
        <div className={styles.filterSectionone}>
          <select
            value={filterRange.pat}
            onChange={(e) => handleFilterRangeChange("pat", e.target.value)}
            className={styles.filterselectinput}
          >
            <option value="">Select PAT (Profit After Tax)</option>
            <option value="0-100000">0 to 1 Lakh</option>
            <option value="100000-500000">1 to 5 Lakh</option>
            <option value="500000-1000000">5 Lakh to 10 Lakh</option>
            <option value="1000000-50000000">10 Lakh to 50 Lakh</option>
            <option value="50000000- 100000000">50 Lakh to 1 Crore</option>
            <option value="100000000-Infinity">1 Crore and above</option>
          </select>
        </div>
      </div>

      {/* Investment Range */}
      <div className={styles.filtersContainer_main}>
        <h4>Investment Range</h4>
        <div className={styles.filterSectionone}>
          <select
            value={filterRange.investmentRange}
            onChange={(e) =>
              handleFilterRangeChange("investmentRange", e.target.value)
            }
            className={styles.filterselectinput}
          >
            <option value="">Select Investment Range</option>
            <option value="0-100000">0 to 1 Lakh</option>
            <option value="100000-500000">1 to 5 Lakh</option>
            <option value="500000-2500000">5 Lakh to 10 Lakh</option>
            <option value="2500000-50000000">10 Lakh to 50 Lakh</option>
            <option value="50000000- 100000000">50 Lakh to 1 Crore</option>
            <option value="100000000-Infinity">1 Crore and above</option>
          </select>
        </div>
      </div>
    </div>
  );
});

export default Filters;
